<template>
  <div class="second_item">
    <div class="second_item_left" v-if="data">
      <div class="second_item_left_img">
        <img :src="data.member.avatar"/>
      </div>
      <div class="second_item_left_msg">
        <span class="user_name">{{data.member.nickname}}</span>彼は私の作品についてのコメントを発表した
      </div>
      <div class="second_item_left_comment" v-if="data.type=='POST_COMMENT'">{{data.postComment.content}}</div>
      <div class="second_item_left_comment" v-if="data.type=='ARTICLE_COMMENT'">{{data.articleComment.content}}</div>
      <div class="second_item_left_comment" v-if="data.type=='POST_SOURCE_COMMENT'">{{data.postComment.content}}</div>
      <div class="second_item_left_comment" v-if="data.type=='ARTICLE_SOURCE_COMMENT'">{{data.articleComment.content}}</div>
    </div>
    <div class="second_item_oter">
      <div class="second_item_left_time">{{getTime(data.createdDate)}}</div>
      <div class="second_item_left_reply" v-if="data.type!='POST_SOURCE_COMMENT'&&data.type!='ARTICLE_SOURCE_COMMENT'" @click="toCommentFun()">返信</div>
      <!-- <div class="second_item_left_like" @click="likeFun()"><img src="@/assets/imgs/noticeItem_like.png" /></div> -->
      <div class="second_item_left_delete" @click="toDeleteFun(true)"><img src="@/assets/imgs/noticeItem_delete.png" /></div>
    </div>
    <div class="second_item_right">
      <div class="second_item_right_img">
        <img :src="data.postComment.post.images[0]" v-if="data.type=='POST_COMMENT'" />
        <img :src="data.articleComment.article.images[0]" v-if="data.type=='ARTICLE_COMMENT'" />
        <img :src="data.postComment.post.images[0]" v-if="data.type=='POST_SOURCE_COMMENT'" />
        <img :src="data.articleComment.article.images[0]" v-if="data.type=='ARTICLE_SOURCE_COMMENT'" />
      </div>
    </div>
    <div class="second_item_delete_pop" v-if="deleteState">
      <div class="title">通知を削除しますか？</div>
      <div class="pop_btn">
        <div class="pop_btn_item" @click="deleteFun()">確認</div>
        <div class="pop_btn_item" @click="toDeleteFun(false)">キャンセル</div>
      </div>
    </div>
    <div class="second_item_comment" v-if="commentState">
      <div class="second_item_comment_input">
        <el-input v-model="comment" :placeholder="'@'+data.member.nickname+'：'" class="input-with-select"></el-input>
      </div>
      <div class="second_item_comment_btn" @click="replyFun()">送信</div>
    </div>
  </div>
</template>

<script>
import { timeToStr,isEmptyObject } from '@/assets/js/util'
import postDialog from '@/components/Dialog'
import * as json from '@/assets/js/json'
export default {
  props:{
    data:{
      type:Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return{
      deleteState: false,
      commentState: false,
      comment: '',
    }
  },
  created () {
  },
  methods: {
    toDeleteFun(state){
      this.deleteState = state
    },
    toCommentFun(){
      if(this.commentState){
        this.commentState = false
      }else{
        this.commentState = true
      }
    },
    likeFun(){
    },
    replyFun(){
      if(this.data.type=='ARTICLE_COMMENT'){
        json.post('/api/member/article/comment/add',{content:this.comment,articleId:this.data.articleComment.articleId,replyId:this.data.articleComment.id}).then((res) =>{
          if(res.data.success){
            this.comment = null
            this.toCommentFun()
            this.$notify({
              title: '',
              message: '回复成功',
              type: 'success'
            });
          }
        })
      }else if(this.data.type=='POST_COMMENT'){
        json.post('/api/member/post/comment/add',{content:this.comment,postId:this.data.postComment.postId,replyId:this.data.postComment.id}).then((res) =>{
          if(res.data.success){
            this.comment = null
            this.toCommentFun()
            this.$notify({
              title: '',
              message: '回复成功',
              type: 'success'
            });
          }
        })
      }
    },
    deleteFun(){
      const user = this.$store.state.userInfo
      const cacheCommentMsg = this.$store.state.commentMsg
      let list = []
      if (!isEmptyObject(cacheCommentMsg)) {
        console.log(cacheCommentMsg[user.id])
        for (let i = 0; i < cacheCommentMsg[user.id].length; i++) {
          if(this.data.createdDate != cacheCommentMsg[user.id][i].createdDate){
            list.push(cacheCommentMsg[user.id][i])
          }
        }
        cacheCommentMsg[user.id] = list
        this.$store.commit('SET_UNREAD_COMMENT_MSG', cacheCommentMsg)
        this.$notify({
          title: '',
          message: '删除成功',
          type: 'success'
        });
        this.$parent.fetch()
        this.toDeleteFun()
      }
    },
    getTime(time){  
      return timeToStr(time)
    },
  }
}
</script>
<style scoped>
  .second_item{
  width: 770px;
  margin: 0 auto;
  margin-top: 22px;
  padding-bottom: 17px;
  position: relative;
  border-bottom: 1px solid #EBEBEB;
}
.second_item_left{
  position: relative;
  height: 80px;
}
.second_item_left_img{
  width: 55px;
  height: 55px;
  position: absolute;
  top: 10px;
  left: 0px;
}
.second_item_left_img img{
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.second_item_left_msg{
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  position: absolute;
  left: 70px;
  top: -7px;
}
.second_item_left_msg .user_name{
  color: #3399CC;
  margin-right: 16px;
}
.second_item_left_time{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  position: absolute;
  left: 68px;
}
.second_item_left_reply{
  position: absolute;
  left: 160px;
  font-size: 14px;
  color: #666666;
  line-height: 14px;
  cursor: pointer;
}
.second_item_left_like{
  width: 16px;
  height: 16px;
  position: absolute;
  left: 207px;
  font-size: 14px;
  color: #666666;
  line-height: 16px;
  cursor: pointer;
}
.second_item_left_like img{
  width: 16px;
  height: 15px;
}
.second_item_left_delete{
  width: 16px;
  height: 16px;
  position: absolute;
  left: 207px;
  font-size: 14px;
  color: #666666;
  line-height: 16px;
  cursor: pointer;
}
.second_item_left_delete img{
  width: 16px;
  height: 15px;
}
.second_item_right{
  position: absolute;
  top: 0px;
  right: 0px;
}
.second_item_right_img{
  width: 80px;
  height: 80px;
}
.second_item_right_img img{
  width: 80px;
  height: 80px;
  background: #DDDDDD;
  border-radius: 10px;
}
.second_item_delete_pop{
  width: 172px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 45px;
  left: 213px;
}
.second_item_delete_pop .title{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  text-align: center;
  margin-top: 14px;
}
.pop_btn{
  width: 100%;
  margin-top: 14px;
  font-size: 12px;
  font-weight: 300;
  color: #666666;
  text-align: center;
}
.pop_btn_item{
  display: inline-block;
  width: 73px;
  height: 20px;
  line-height: 20px;
  background: #F6F6F6;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
}
.pop_btn_item:last-child{
  margin-left: 8px;
}
.second_item_left_comment{
  width: 448px;
  font-size: 14px;
  font-weight: 300;
  color: #333333;
  line-height: 24px;
  position: absolute;
  top: 21px;
  left: 70px;
}
.second_item_oter{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  height: 16px;
  line-height: 16px;
  position: relative;
}
.second_item_comment{
  width: 100%;
  margin-top: 32px;
  height: 57px;
  position: relative;
}
.second_item_comment_input{
  width: 663px;
  height: 57px;
  background: #F6F6F6;
  border-radius: 6px;
  position: absolute;
  left: 0;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 57px;
}
.second_item_comment_btn{
  width: 80px;
  height: 57px;
  background: #F6F6F6;
  border-radius: 6px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 57px;
  position: absolute;
  right: 0px;
  cursor: pointer;
}
</style>